// extracted by mini-css-extract-plugin
module.exports = {"container":"_CzAanQy","progressArea":"_zYvSwkz","title":"d0lzGtlP","circleIcon":"__8O83z8PJ","line":"xJbJ9FBI","value":"_q80Rub2"};